import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { UpdateUserMappingForm } from './user-mapping-edit-page';

interface ResetUserMappingEditFormProps {
  defaultForm: UpdateUserMappingForm;
}
export function ResetUserMappingEditForm({ defaultForm }: ResetUserMappingEditFormProps) {
  const { reset } = useFormContext();

  useEffect(() => {
    reset(defaultForm);
  }, [reset, defaultForm]);
  return null;
}
